var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2.98023e-08C17.747 2.98023e-08 18.4302 0.273024 18.9554 0.724728L18.2452 1.4348C17.9035 1.16264 17.4708 1 17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V9.318L20 8.318V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V3C0 1.34315 1.34315 2.98023e-08 3 2.98023e-08H17ZM9.90422 17H7V14.0958L18.8522 2.24397C18.852 2.24364 18.8519 2.24332 18.8518 2.24299L19.3429 1.75285L19.926 2.33498L19.926 2.336L22.2471 4.65707L9.90422 17ZM8.45211 14.0958L8.0268 14.5211V15.9732H9.47891L9.90422 15.5479L8.45211 14.0958ZM17.8908 4.65707L10.6303 11.9176L11.3563 12.6437L18.6169 5.38312L17.8908 4.65707ZM22.2471 0.300742L23.6993 1.75285C24.1002 2.15384 24.1002 2.80397 23.6993 3.20496L22.9732 3.93102L20.069 1.0268L20.795 0.300742C21.196 -0.100247 21.8462 -0.100247 22.2471 0.300742Z",
    fill: "#4A4A4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrey);
export default __webpack_public_path__ + "static/media/grey.d3097b47611613a56c4ea1126ecc5d8d.svg";
export { ForwardRef as ReactComponent };